import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-inventory-tabs',
  templateUrl: './inventory-tabs.component.html',
  styleUrls: ['./inventory-tabs.component.scss']
})
export class InventoryTabsComponent implements OnInit {

  userPermissions: any = this.uService.userPermissions;

  constructor(public uService: UtilsService) { }

  ngOnInit(): void {
  }

}
